module.exports = __webpack_public_path__ + "img/ring_skip_skip_0_0@2x.a87f4c1e.png";